<template>
  <ConfigErrorBoundary>
    <FileConverter
      :config="converterConfig"
      @batch-created="handleBatchCreated"
      @job-completed="handleJobCompleted"
      @batch-cleared="handleBatchCleared"
      @error="handleError"
      @credits-updated="handleCreditsUpdated"
    />
  </ConfigErrorBoundary>
</template>

<script setup lang="ts">
import FileConverter from './FileConverter.vue';
import ConfigErrorBoundary from './ConfigErrorBoundary.vue';
import { parseAndValidateConverterConfig } from '../utils/ConfigValidator';

// Parse and validate configuration using fail-fast Zod validation
// This replaces the old manual JSON parsing + lazy fallbacks pattern
// If config is invalid, parseAndValidateConverterConfig() throws with detailed error
// NOTE: jobCategory, labels, and creditCost are now provided by backend
const converterConfig = parseAndValidateConverterConfig('heic-to-webp-converter', 'HEIC → WebP');

// Event handlers
function handleBatchCreated(batchId: string) {
  console.log('[HEIC→WebP Converter] Batch created:', batchId);
}

function handleJobCompleted(jobId: string) {
  console.log('[HEIC→WebP Converter] Job completed:', jobId);
}

function handleBatchCleared() {
  console.log('[HEIC→WebP Converter] Batch cleared');
}

function handleError(error: Error) {
  console.error('[HEIC→WebP Converter] Error:', error);
}

function handleCreditsUpdated(credits: number) {
  console.log('[HEIC→WebP Converter] Credits updated:', credits);
}
</script>
